const Preloader = require('../../../../layout/preloader/index');
const css = require('./price.css');

class Price {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        const isHeader = 'cat-header' in this.$context.attributes;

        return this.$context.getWatcherData().then(
            (data) => {
                const totalPrice = data.typeId === 4 ? data.orderAmount : data.totalPrice;

                return Object.assign({}, { isHeader }, data, { css }, { totalPrice });
            });
    }
}

module.exports = {
    constructor: Price,
    children: [
        {
            name: 'preloader-small',
            component: Preloader,
            props: {
                size: 'small'
            }
        },
        {
            name: 'preloader',
            component: Preloader
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/price/index.js